import React from "react";
import { getLevelInfo } from "../../../utils";
import styles from "./levelInfo.module.scss";
const LevelInfoLabel = ({ status, enabled, policyLevel, scanLevel, }) => {
    return (React.createElement("div", { className: styles.label }, getLevelInfo({
        policyLevel,
        status,
        enabled,
        scanLevel,
    })));
};
export default LevelInfoLabel;
//# sourceMappingURL=LevelInfoLabel.js.map